import React from 'react'

import Button from '../form/Button'
import CloseIcon from '../../../assets/icons/close.svg?react'
import { useI18N } from '../../../libraries/i18n/hook'

type Props = {
  className?: string
  text?: string
  onClearFilter?: () => void
  totalResults?: number
}

const NoResults: React.FC<Props> = ({ className = '', text, onClearFilter, totalResults = 0 }) => {
  const { t } = useI18N()
  const showClearFilters = typeof onClearFilter === 'function' && totalResults > 0

  return (
    <div className={`mt-4 rounded-md bg-gray-300 border border-solid border-gray-100 px-4 py-10 text-gray text-center text-2xs sm:text-xs ${className}`}>
      {text ?? t('common.noResults')}
      {showClearFilters && (
        <div className='mt-1'>
          <Button icon={<CloseIcon className='stroke-dark-green' />} type='button' variant='flat' className='text-dark-green' size='sm' outlined onClick={onClearFilter}>
            {t('content.remove.filters')}
          </Button>
        </div>
      )}
    </div>
  )
}

export default NoResults
